import { createAsyncThunk } from "@reduxjs/toolkit";
import edgarApi from "./edgarAPI";

export const fetchEdgarFilingsData = createAsyncThunk(
  "edgar/fetch",
  async (ticker, { getState, rejectWithValue }) => {

    if (!ticker || typeof ticker !== "string") {
      console.warn("Invalid EDGAR ticker:", ticker);
      return rejectWithValue("invalid-ticker");
    }

    const state = getState().edgar;

    // ✅ CACHE HIT → return existing data as fulfilled
    if (state.lastFetchedTicker === ticker && state.filings?.length > 0) {
      return {
        company_info: state.companyInfo,
        filings: state.filings,
      };
    }

    try {
      return await edgarApi.getFilings(ticker, 20, true);
    } catch (err) {
      return rejectWithValue(err?.response?.data || "EDGAR fetch failed");
    }
  }
);
